import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-156f469e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "inline-flex align-items-center switch-lg" }
const _hoisted_2 = { class: "text-switch" }
const _hoisted_3 = ["onClick"]


export default /*#__PURE__*/_defineComponent({
  __name: 'TextSwitch',
  props: {
    modelValue: null,
    values: null,
    disabled: { type: Boolean }
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: emits }: { emit: ({
  (e: 'update:modelValue', value: string): void;
}), expose: any, slots: any, attrs: any }) {





const updateModel = value => {
  emits('update:modelValue', value);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.values, (item) => {
        return (_openBlock(), _createElementBlock("div", {
          key: item,
          class: _normalizeClass(["text-switch-item", { checked: item.value === __props.modelValue }]),
          onClick: ($event: any) => (__props.disabled === false ? updateModel(item.value) : null)
        }, _toDisplayString(item.label), 11, _hoisted_3))
      }), 128))
    ])
  ]))
}
}

})